import { Component, inject, OnInit } from '@angular/core';
import { PageResumePresenter } from './ui-commons/page_resume.presenter';
import { PaymentBusEventsService } from '../../services/payment.busevents.service';
import { LoaderSubjectService } from "../../../../shared/ui-commons/ui-spinner/util-commons/service/loader-subject.service";
import { IMakeTransferResponse } from "../../services/interfaces/izipai-make-transfer.interfaces";
import { MakeTransferService } from "../../services/izipai-make-transfer.service";
import { MonitorService } from '../../services/fingerprint.service';
import { switchMap } from "rxjs";
import { UICardContainerComponent } from "../../../../shared/ui-commons/ui-card-page/ui-card-page.components";
import { LocationAssetsPipe } from "@utils/pipes/location-assets.pipe";
import { NewRelicService } from '../../services/newRelic.service';
import { Router } from '@angular/router';

@Component({
  selector: 'cv-page-transfer-resume',
  templateUrl: './page-transfer-resume.component.html',
  imports: [
    UICardContainerComponent,
    LocationAssetsPipe
  ]
})
export class PageTransferResumeComponent implements OnInit {
  public prp = new PageResumePresenter();

  private newRelicService = inject(NewRelicService);
  private readonly pbes = inject(PaymentBusEventsService);
  private readonly loader = inject(LoaderSubjectService);
  private readonly mts = inject(MakeTransferService);
  private readonly monitorService = inject(MonitorService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    const event = this.pbes.getCurrentEvent();
    if (event.code === 'PAYMENT-COMPLETE') {
      this.loader.showLoader();
      this.newRelicService.addPageAction('PAYMENT-COMPLETE-TRANSFER', {
        component: 'PageTransferResumeComponent',
        action: 'Resumen-pago',
        detail: 'Post ShowLoader',
        timestamp: new Date().toISOString()
      });

      this.monitorService.startMonitorData()
        .pipe(
          switchMap((monitorData) => {
            // Loguear si monitorData es null (error de fingerprint)
            if (!monitorData) {
              this.newRelicService.addPageAction('FINGERPRINT-WARNING', {
                component: 'PageTransferResumeComponent',
                action: 'startMonitorData',
                detail: 'Monitor Data es null - Usando valores por defecto',
                timestamp: new Date().toISOString()
              });
            } else {
              this.newRelicService.addPageAction('PAYMENT-COMPLETE-TRANSFER', {
                component: 'PageTransferResumeComponent',
                action: 'startMonitorData',
                detail: 'Monitor Data obtenido correctamente',
                timestamp: new Date().toISOString()
              });
            }
            return this.mts.internalMakeAviTransfer(monitorData, event);
          })
        )
        .subscribe({
          next: (response: IMakeTransferResponse) => {
            this.newRelicService.addPageAction('TRANSFER-COMPLETE', {
              component: 'IMakeTransferResponse',
              action: 'subscribe-exitoso',
              detail: 'Response Transfer: ' + JSON.stringify(response),
              timestamp: new Date().toISOString()
            });
            const currencySymbol = event.infoIzipay?.currency === 'PEN' ? 'S/. ' : '$. ';
            this.prp.transfer_data.operation = response.operationNumber;
            this.prp.transfer_amount.amount = currencySymbol + event.infoIzipay?.amount;
            this.pbes.reset();
            this.loader.closeLoader();
          },
          error: (err) => {
            this.newRelicService.addPageAction('TRANSFER-ERROR', {
              component: 'IMakeTransferResponse',
              action: 'subscribe-error',
              detail: 'Response Transfer: '
                + ' message: ' + err.message
                + ' stacks' + err.stack
                + ' error: ' + err.error
                + ' name: ' + err.name
                + ' status: ' + err.status
                + ' statusText: ' + err.statusText
                + ' url: ' + err.url
                + ' toString: ' + err.toString()
                + ' JSON: ' + JSON.stringify(err),
              timestamp: new Date().toISOString()
            });
            this.loader.closeLoader();
            this.router.navigate(['/error']);
          },
          complete: () => {
            this.loader.closeLoader();
          }
        });
    }
  }
}